import { render } from "./HelixCheckboxes.vue?vue&type=template&id=fe634a6e"
import script from "./HelixCheckboxes.vue?vue&type=script&lang=js"
export * from "./HelixCheckboxes.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__